module.exports = __webpack_public_path__ + "static/media/store-solid.fd89e316.svg";